var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"shadow-box pa55"},[_c('div',{staticClass:"con con-pdf"},[_c('el-card',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sample)}})])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }